import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

export const companySmsSendingRuleMappingsItemSchema = yup.object({
	salonId: yup.number().required(),
	companySmsSendingRuleId: yup
		.string()
		.required("各店舗にルールを1つ選択してください。"),
})

export type CompanySmsSendingRuleMappingsItem = yup.InferType<
	typeof companySmsSendingRuleMappingsItemSchema
>

export const companySmsSendingRuleMappingsSchema = yup.object({
	items: yup
		.array()
		.of(companySmsSendingRuleMappingsItemSchema)
		.required()
		.min(0),
})

export type CompanySmsSendingRuleMappingsForm = yup.InferType<
	typeof companySmsSendingRuleMappingsSchema
>

export const companySmsSendingRuleMappingsResolver = yupResolver(
	companySmsSendingRuleMappingsSchema
)
